export default __webpack_public_path__ + "static/media/brady_logo_blue_288_svg.69478f3e.svg";